// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class NonFixedInstumentStrikesRequest extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_INSTRUMENT_STRIKES_REQUEST, fieldSet);
    }
    setContractID(contractID) {
        this.setFieldValue(FieldsFactory.FIELD_CONTRACT_ID, contractID);
    }
    setRequestId(p) {
        this.setFieldValue(FieldsFactory.FIELD_REQUEST_ID, p);
    }
}
